import React from 'react'
// import * as items from '../../folio_items.js'
import './style.scss'

import Item from './Item'
import DevItem from './DevItem'

const Portfolio = ({ items, setItems }) => {
  const dev = /\?dev=true/gi.test(window.location.search) && window.location.hostname === 'localhost'

  function generateFolioItems () {
    const out = []
    items.forEach((item, idx) => {
      out.push (
        dev
        ? <DevItem key={`folio_item_${idx}`} items={items} item={item} setItems={setItems} />
        : <Item key={`folio_item_${idx}`} item={item} />
      )
    })
    return out
  }

  return (
    <section id="portfolio">
      <div className="title">
        <h2>Portfolio</h2>
      </div>
      <div className="folio">
        <div className="folio__items" style={dev ? { transform: 'none' } : {}}>
          { generateFolioItems () }
        </div>
      </div>
    </section>
  )
}

export default Portfolio
